module.exports = __webpack_public_path__ + "media/images/athletes/3561-2dd94f41364003707b887abcce23467c.png";